import { motion } from 'framer-motion'
import { cn } from '@/lib/utils'
import { SectionHeading } from '@/components/ui/SectionHeading'

interface TreatmentTextBlockProps {
  title?: string
  paragraphs: string[]
  background?: 'white' | 'cream' | 'soft'
  className?: string
}

export function TreatmentTextBlock({
  title,
  paragraphs,
  background = 'cream',
  className,
}: TreatmentTextBlockProps) {
  if (!paragraphs || paragraphs.length === 0) return null

  const bgClass = {
    white: 'bg-white',
    cream: 'bg-cream',
    soft: 'bg-primary-soft',
  }[background]

  return (
    <section className={cn('py-16 md:py-24', bgClass, className)}>
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        {title && <SectionHeading title={title} centered />}
        <div className={cn('space-y-4', title && 'mt-8')}>
          {paragraphs.map((paragraph, index) => (
            <motion.p
              key={index}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-50px' }}
              transition={{ duration: 0.4, delay: index * 0.05 }}
              className="leading-relaxed text-muted"
            >
              {paragraph}
            </motion.p>
          ))}
        </div>
      </div>
    </section>
  )
}
